import { Component } from '@angular/core';
import { NavigationComponent } from '@features/navigation/components/navigation/navigation.component';
import { UserRegisterDetailComponent } from '@features/user/components/user-register-detail/user-register-detail.component';

@Component({
    selector: 'app-user-register-page',
    templateUrl: './user-register-page.component.html',
    imports: [NavigationComponent, UserRegisterDetailComponent],
})
export class UserRegisterPageComponent {}
